import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { cm } from 'src/utils/classNames';

function Content({
	className,
	...rest
}: RadixCollapsible.CollapsibleContentProps) {
	return (
		<RadixCollapsible.Content
			className={cm(
				'shrink-0 overflow-hidden',
				'data-[state=open]:animate-collapsible-slide-down',
				'data-[state=closed]:animate-collapsible-slide-up',
				className
			)}
			{...rest}
		/>
	);
}

export default {
	Root: RadixCollapsible.Root,
	Trigger: RadixCollapsible.Trigger,
	Content,
};
